import { TablePaginationOptions } from '../tables/tables.types';

export const TAX_ACCOUNTING_TAX_TYPES = ['TVA', 'TVM'] as const;
export const TAX_ACCOUNTING_AMOUNT_TYPES = ['HT', 'TAXE'] as const;
export const TAX_ACCOUNTING_AMOUNT_SUB_TYPES = [
  'accessory',
  'battery',
  'battery_order',
  'charger',
  'consumable',
  'device',
  'hard_drive',
  'keyboard',
  'mouse',
  'ram',
  'shipping_fees',
  'warranty'
] as const;

/* Type de vente auquel la règle s'applique. 'ALL' est le cas général : il ne sert
 * que si aucune règle ne vise explicitement le type de vente de la facture. */
export const TAX_ACCOUNTING_SALE_TYPES = ['ALL', 'BtoB', 'BtoC'] as const;

export const TAX_ACCOUNTING_SALE_TYPE_LABELS: Record<string, string> = {
  ALL: 'Tous',
  BtoB: 'Professionnel (BtoB)',
  BtoC: 'Particulier (BtoC)'
};

export interface TaxAccountingEntry {
  id: number;
  country_code: string;
  tax_type: string;
  amount_type: string;
  amount_sub_type: string | null;
  sale_type: string;
  accounting_account: string;
  created_at?: string;
  updated_at?: string;
}

export interface TaxAccountingEntryPayload {
  country_code: string;
  tax_type: string;
  amount_type: string;
  amount_sub_type?: string | null;
  sale_type: string;
  accounting_account: string;
}

export interface TaxAccountingEntriesListOptions {
  filters?: Partial<Record<keyof TaxAccountingEntry, string | string[]>> & { fulltext?: string };
  pagination?: TablePaginationOptions;
}
